import { Context } from "../../context";
import { CameraModeOptions, ControllerStrategy } from "../strategy/strategy";
import { PersonalControllerStrategy } from "./personal";

const cameraModeOptions: CameraModeOptions = {
  focusedID: 10,
};

export class BatterControlStrategy extends PersonalControllerStrategy {
  init(context: Context, _options?: CameraModeOptions): ControllerStrategy {
    return super.init(context, cameraModeOptions);
  }
}
